import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const StoreFilledIcon = props => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={23}
    viewBox="0 0 24 23"
    fill="none"
    {...props}>
    <Path
      fill="#3876AA"
      d="M8.866 1.833a1 1 0 1 0-1.732-1L4.92 4.667H3.333a2.667 2.667 0 0 0-1.41 4.93c.076.047.166.07.256.07h19.642c.09 0 .18-.023.257-.07a2.667 2.667 0 0 0-1.411-4.93h-1.588L16.866.833a1 1 0 0 0-1.732 1l1.636 2.834H7.23l1.636-2.834Z"
    />
    <Path
      fill="#3876AA"
      fillRule="evenodd"
      d="M21.78 11.98a.267.267 0 0 0-.263-.314H2.483a.267.267 0 0 0-.263.313l1.334 7.598A3.698 3.698 0 0 0 6.687 22.6c3.525.49 7.101.49 10.626 0a3.698 3.698 0 0 0 3.133-3.023l1.334-7.598Zm-11.447 2.686a1 1 0 1 0-2 0v2.667a1 1 0 1 0 2 0v-2.666Zm4.334-1a1 1 0 0 1 1 1v2.667a1 1 0 1 1-2 0v-2.666a1 1 0 0 1 1-1Z"
      clipRule="evenodd"
    />
  </Svg>
);
export default StoreFilledIcon;
